export const environment = {
  production: false,
  ApiURL: 'https://api.test3.acv.3plheroes.com/api', // This is proxied on local dev to avoid CORS
  SupersetURL: 'https://superset.3plheroes.com',
  mapBoxToken: 'pk.eyJ1IjoiaXJ0aXphLXNoaXNwYXJlIiwiYSI6ImNtY2o1amhwZDAwaG0yanF4NHBmNzZ2N3MifQ.cDmBbccwq9oiu2TushTWlQ',
};
